import React from "react";
import InternalLink from "../../components/InternalLink";
import Logo from "@ui/Logo";
import Icon from "../../components/Icon";
import LanguageSwitcher from "../../components/LanguageSwitcher";

function DocsHeader({ onMenuClick, links }) {
    // Get the back to app link (last in the array)
    const backToAppLink = links[links.length - 1];

    return (
        <header className="sticky top-0 z-50 border-b border-gray-200  bg-white ">
            <div className="mx-auto px-4">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center ">
                        <button
                            onClick={onMenuClick}
                            className="lg:hidden -ml-2 p-2 rounded-md text-gray-500 hover:text-gray-900  "
                        >
                            <Icon name="Menu" size={24} />
                        </button>

                        <div className="mr-4">
                            <InternalLink to="/">
                                <Logo className="h-8 text-gray-900 " />
                            </InternalLink>
                        </div>
                        <nav className="hidden lg:flex space-x-8">
                            {links.slice(0, -1).map((link, index) => (
                                <InternalLink
                                    key={index}
                                    to={link.path}
                                    className="text-gray-900  px-3 py-2 text-sm font-medium"
                                >
                                    {link.title}
                                </InternalLink>
                            ))}
                        </nav>
                    </div>
                    <div className="flex items-center space-x-4">
                        <LanguageSwitcher />
                        <InternalLink
                            to="/"
                            className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                        >
                            <Icon name="ArrowLeft" size={16} className="mr-1" />
                            {backToAppLink.title}
                        </InternalLink>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default DocsHeader;
